import { dictionary } from "./i18n/dictionary";

export const lidLabels = {
  manual: dictionary.manual,
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4"
};
